export const REMOVE = 'Remove';
export const CANCEL = 'Cancel';
export const ATTACH_FILES = 'Attach files';
export const ATTACH_WORKKARD_FILES = 'Attach workkard files';
export const ATTACH_WORKKARD_LETTER = 'Attach Letter';
export const INVALID_FILE_EXTENSION = 'INVALID_FILE_EXTENSION';
export const INVALID_FILE_SIZE = 'INVALID_FILE_SIZE';
export const VALID_FILE = 'VALID_FILE';

export const INVALID_FILE_EXTENSION_ERROR = 'Invalid file format';
export const INVALID_FILE_SIZE_ERROR = 'Invalid file, upload upto';
export const SERVER_UNAVAILABLE_ERROR_MESSAGE = 'Server is currently unavailable.';
export const MALICIOUS_OR_VIRUS_INFECTED_ERROR = 'File is malicious or virus infected.';
